import React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import { ExternalEnumOverviewEngine } from "../../component/externalEnumOverviewEngine";

import { ProcessOverviewEngine } from "./components/processOverviewEngine";
import { openTaskDocumentAndShowWiedervorlagenSaga, openTaskDocumentSaga } from "./sagas/openTaskDocumentSagas";
import { openProcessAfterCompleteSaga, openProcessAfterStartSaga } from "./sagas/openProcessSagas";
import { retryTaskPermissionSaga } from "./sagas/checkTaskPermissionSaga";
import { taskAssignmentDoneMiddleware } from "./middleware/taskAssignmentDoneMiddleware";
import { DeleteProcessConfirmModal } from "./components/deleteProcessConfirmModal";
import { deleteProcessDocumentSaga } from "./sagas/deleteProcessDocumentSaga";
import { ChangeMembershipModal } from "./components/changeMembershipModal";
import { changeZugehoerigkeitSaga } from "./sagas/changeZugehoerigkeitSaga";

/**
 * Client Modul für eine Overview die in einem
 * Fachverfahrens-Prozess benutzt werden kann.
 * Das Modul kann einen neuen Prozess starten
 * und ein Formular im aktuellen Schritt mit der
 * Doppelansicht (Links Antrag, Rechts Aktueller Schritt)
 * anzeigen.
 *
 * Dokumentation getA12:
 *    Client Keywords:
 *        Modularization (Features > Modularization)
 */
const processOverviewModule = (): Module => ({
	id: "ProcessOverview",
	views: () => viewComponentProvider,
	sagas: () => [
		openProcessAfterCompleteSaga,
		openProcessAfterStartSaga,
		openTaskDocumentSaga,
		openTaskDocumentAndShowWiedervorlagenSaga,
		retryTaskPermissionSaga,
		deleteProcessDocumentSaga,
		changeZugehoerigkeitSaga
	],
	middlewares: () => [taskAssignmentDoneMiddleware]
});

const components: { [name: string]: React.ComponentType<View> | undefined } = {
	ProcessOverviewEngine,
	ExternalEnumOverviewEngine,
	DeleteProcessConfirmModal,
	ChangeMembershipModal
};

function viewComponentProvider(name: string) {
	return components[name];
}

export default processOverviewModule;
